// @ts-check
import { defineStore } from "pinia";

export const useCommonStore = defineStore({
  id: "common",
  state: () => ({
    dateFilter: "",
    policyFilter: {
      type: 'interval',
      data: {
        startVersion: {},
        endVersion: {},
      }
    },
    hourDifference: 0,
    dropdownDate: null,
  }),
  actions: {
    setDropdownDate(dropdownDate) {
      this.dropdownDate = dropdownDate
    },
    setDateFilter(dateFilter) {
      this.dateFilter = dateFilter
    },
    setPolicyFilter(filter) {
      this.policyFilter = filter;
    },
    setHourDifference(hourDifference) {
      this.hourDifference = hourDifference
    }
  }
});
